// import Utils from '../../modules/utils'
// import copyCadToVendorOrders from './copy-cad-to-vendor-orders.js'
import $ from 'jquery'
import {orgText} from '../cads/cache/get.js'

const getArchivedVpos = (orgId, callbackFunc) => {
  ////OLD
  // Utils.get('archived_vpos/', (err, res) =>
  // {
  //   if (err) {
  //     alert('There was an error when trying to get archived vendor orders.')
  //   } else {
  //     if (res.data.success) {
  //       window.archivedVpos = JSON.parse(res.data.data)
  //       window.numberOfApiSuccess += 1
  //       if (window.numberOfApiSuccess == 3) {callbackFunc()}
  //     }
  //   }
  // })

  ////NEW
  let randomNum = Math.floor(Math.random()*99999999).toString()
  let url = 'https://' + process.env.REACT_APP_S3_BUCKET_NAME + '.s3.amazonaws.com/caches/archived_vpos' + orgText(orgId) + '.json?t=' + randomNum

  $.get(url, function(res) {
    window.archivedVpos = JSON.parse(res)
    window.numberOfApiSuccess += 1
    if (window.numberOfApiSuccess == 3) {callbackFunc()}
  })

}

export {getArchivedVpos}
